import { iconBaseProps, type IconProps } from "@/components/ui/icons/icon-base"

export const TruckFastIcon = ({ size = 22, ...props }: IconProps) => (
  <svg {...iconBaseProps(size, props)} fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round">
    <path d="M8 7h7v9H8z" />
    <path d="M15 11h3l3 3v2h-6" />
    <circle cx="11" cy="17.6" r="1.4" />
    <circle cx="18" cy="17.6" r="1.4" />
    <path d="M1.5 9.5h3.5M1 13h4.5M2.5 16.5h2.5" />
  </svg>
)
